// extracted by mini-css-extract-plugin
module.exports = {"wrap":"RailBell_wrap__Hioeq","dot":"RailBell_dot__javoX"};